var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-game-root"},[_c('canvas',{ref:"gameCanvas",staticClass:"game-canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }